import React, { useState }  from "react"
import { Div, Text, Container } from "atomize";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import theme from './../../../Theme/Theme';
import { pages } from "../../../Constants/constants";
import Logo from "./../../../Assets/branding/logo.png";


const Wrapper = styled(Div)`
  background-color: ${theme.colors.alphaPrimary};
  margin-top: 4rem; 
  border-top: 1px solid #C9CED6;
`;

const Grid = styled(Div)`
  display: flex;
  padding: 4rem 0;
  justify-content: space-between;
  
  @media (max-width: 992px) {
    flex-direction: column;
  }
  @media (max-width: 992px) {
    > div {
      margin-bottom: 2rem;
    }
  }
`;

const RightCol = styled(Div)`
  img {
    width: 175px;
  }
`;

const LeftCol = styled(Div)`
  display: flex;
  p {
    font-family: Inter;
    font-size: 14px;
    color: #8A94A6;
    letter-spacing: 0;
    line-height: 20px;  
  }
`;

const CenterCol = styled(Div)`
  h3 {
    color: #0A1F44;	
    font-family: Inter;	
    font-size: 14px;	
    font-weight: bold;	
    line-height: 24px;
  }
  a {
    color: #0A1F44;	
    font-family: Inter;	
    font-size: 14px;	
    font-weight: 500;	
    line-height: 24px;
    margin-right: 1rem;
  }
  .links {
    display: flex;
    flex-wrap: wrap;
  }
`;

function Footer(props) {

  return (
    <Wrapper
    >
      <Container>
        <Grid>
          <RightCol>
            <a target={"_blank"} rel="noopener noreferrer" href={"http://www.olin.edu/"}>
              <img src={Logo} alt={'Olin college for Engineering'}/>
            </a>
          </RightCol>
          <CenterCol>
            <h3>Engineering for Humanity</h3>
            <div className={'links'}>
              {
                pages.map ( page => {
                  return (
                    <NavLink
                      key={page}
                      to={page === 'overview' ? '/' : '/' + page}
                    >
                      {page.charAt(0).toUpperCase() + page.slice(1)}
                    </NavLink>
                  )
                })
              }
            </div>
          </CenterCol>
          <LeftCol>
            <RightCol>
              <p>Contact</p>
              <a href={'mailto:E4H@Olin.edu'}>E4H@Olin.edu</a>
            </RightCol>
            <LeftCol>
              <p>Copyright © 2019</p>
            </LeftCol>
          </LeftCol>
        </Grid>
      </Container>
    </Wrapper>
  )
}



export default Footer
